import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { promotionsRoute } from '.'

const Promotions = lazyRouteComponent(() => import('../../pages/promotions'))

export const promotionsIndexRoute = createRoute({
  getParentRoute: () => promotionsRoute,
  path: '/',
  component: Promotions,
})
